import { render, staticRenderFns } from "./RateApplication.vue?vue&type=template&id=3beb1352"
import script from "./RateApplication.vue?vue&type=script&lang=js"
export * from "./RateApplication.vue?vue&type=script&lang=js"
import style0 from "./RateApplication.vue?vue&type=style&index=0&id=3beb1352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports